/**
 * Comprehensive list of dog breeds
 * Includes AKC recognized breeds, popular designer breeds, and common mixes
 * Alphabetically sorted for easy browsing
 */

export const DOG_BREEDS = [
  // Popular options at the top
  { value: 'Mixed', label: 'Mixed Breed' },
  { value: 'Unknown', label: 'Unknown' },

  // A
  { value: 'Affenpinscher', label: 'Affenpinscher' },
  { value: 'Afghan Hound', label: 'Afghan Hound' },
  { value: 'Airedale Terrier', label: 'Airedale Terrier' },
  { value: 'Akita', label: 'Akita' },
  { value: 'Alaskan Klee Kai', label: 'Alaskan Klee Kai' },
  { value: 'Alaskan Malamute', label: 'Alaskan Malamute' },
  { value: 'American Bulldog', label: 'American Bulldog' },
  { value: 'American Eskimo Dog', label: 'American Eskimo Dog' },
  { value: 'American Foxhound', label: 'American Foxhound' },
  { value: 'American Pit Bull Terrier', label: 'American Pit Bull Terrier' },
  { value: 'American Staffordshire Terrier', label: 'American Staffordshire Terrier' },
  { value: 'American Water Spaniel', label: 'American Water Spaniel' },
  { value: 'Anatolian Shepherd Dog', label: 'Anatolian Shepherd Dog' },
  { value: 'Australian Cattle Dog', label: 'Australian Cattle Dog' },
  { value: 'Australian Shepherd', label: 'Australian Shepherd' },
  { value: 'Australian Terrier', label: 'Australian Terrier' },
  { value: 'Aussiedoodle', label: 'Aussiedoodle' },

  // B
  { value: 'Basenji', label: 'Basenji' },
  { value: 'Basset Hound', label: 'Basset Hound' },
  { value: 'Beagle', label: 'Beagle' },
  { value: 'Bearded Collie', label: 'Bearded Collie' },
  { value: 'Beauceron', label: 'Beauceron' },
  { value: 'Bedlington Terrier', label: 'Bedlington Terrier' },
  { value: 'Belgian Malinois', label: 'Belgian Malinois' },
  { value: 'Belgian Sheepdog', label: 'Belgian Sheepdog' },
  { value: 'Belgian Tervuren', label: 'Belgian Tervuren' },
  { value: 'Bernedoodle', label: 'Bernedoodle' },
  { value: 'Bernese Mountain Dog', label: 'Bernese Mountain Dog' },
  { value: 'Bichon Frise', label: 'Bichon Frise' },
  { value: 'Black and Tan Coonhound', label: 'Black and Tan Coonhound' },
  { value: 'Black Russian Terrier', label: 'Black Russian Terrier' },
  { value: 'Bloodhound', label: 'Bloodhound' },
  { value: 'Blue Heeler', label: 'Blue Heeler' },
  { value: 'Bluetick Coonhound', label: 'Bluetick Coonhound' },
  { value: 'Boerboel', label: 'Boerboel' },
  { value: 'Border Collie', label: 'Border Collie' },
  { value: 'Border Terrier', label: 'Border Terrier' },
  { value: 'Borzoi', label: 'Borzoi' },
  { value: 'Boston Terrier', label: 'Boston Terrier' },
  { value: 'Bouvier des Flandres', label: 'Bouvier des Flandres' },
  { value: 'Boxer', label: 'Boxer' },
  { value: 'Boykin Spaniel', label: 'Boykin Spaniel' },
  { value: 'Briard', label: 'Briard' },
  { value: 'Brittany', label: 'Brittany' },
  { value: 'Brussels Griffon', label: 'Brussels Griffon' },
  { value: 'Bull Terrier', label: 'Bull Terrier' },
  { value: 'Bulldog', label: 'Bulldog' },
  { value: 'Bullmastiff', label: 'Bullmastiff' },

  // C
  { value: 'Cairn Terrier', label: 'Cairn Terrier' },
  { value: 'Canaan Dog', label: 'Canaan Dog' },
  { value: 'Cane Corso', label: 'Cane Corso' },
  { value: 'Cardigan Welsh Corgi', label: 'Cardigan Welsh Corgi' },
  { value: 'Cavalier King Charles Spaniel', label: 'Cavalier King Charles Spaniel' },
  { value: 'Cavapoo', label: 'Cavapoo' },
  { value: 'Chesapeake Bay Retriever', label: 'Chesapeake Bay Retriever' },
  { value: 'Chihuahua', label: 'Chihuahua' },
  { value: 'Chinese Crested', label: 'Chinese Crested' },
  { value: 'Chinese Shar-Pei', label: 'Chinese Shar-Pei' },
  { value: 'Chinook', label: 'Chinook' },
  { value: 'Chow Chow', label: 'Chow Chow' },
  { value: 'Clumber Spaniel', label: 'Clumber Spaniel' },
  { value: 'Cockapoo', label: 'Cockapoo' },
  { value: 'Cocker Spaniel', label: 'Cocker Spaniel' },
  { value: 'Collie', label: 'Collie' },
  { value: 'Coonhound', label: 'Coonhound' },
  { value: 'Corgi', label: 'Corgi' },
  { value: 'Coton de Tulear', label: 'Coton de Tulear' },
  { value: 'Curly-Coated Retriever', label: 'Curly-Coated Retriever' },

  // D
  { value: 'Dachshund', label: 'Dachshund' },
  { value: 'Dalmatian', label: 'Dalmatian' },
  { value: 'Dandie Dinmont Terrier', label: 'Dandie Dinmont Terrier' },
  { value: 'Doberman Pinscher', label: 'Doberman Pinscher' },
  { value: 'Dogo Argentino', label: 'Dogo Argentino' },
  { value: 'Dogue de Bordeaux', label: 'Dogue de Bordeaux' },
  { value: 'Dutch Shepherd', label: 'Dutch Shepherd' },

  // E
  { value: 'English Bulldog', label: 'English Bulldog' },
  { value: 'English Cocker Spaniel', label: 'English Cocker Spaniel' },
  { value: 'English Foxhound', label: 'English Foxhound' },
  { value: 'English Setter', label: 'English Setter' },
  { value: 'English Springer Spaniel', label: 'English Springer Spaniel' },
  { value: 'English Toy Spaniel', label: 'English Toy Spaniel' },
  { value: 'Entlebucher Mountain Dog', label: 'Entlebucher Mountain Dog' },

  // F
  { value: 'Field Spaniel', label: 'Field Spaniel' },
  { value: 'Finnish Lapphund', label: 'Finnish Lapphund' },
  { value: 'Finnish Spitz', label: 'Finnish Spitz' },
  { value: 'Flat-Coated Retriever', label: 'Flat-Coated Retriever' },
  { value: 'French Bulldog', label: 'French Bulldog' },
  { value: 'Frenchton', label: 'Frenchton' },

  // G
  { value: 'German Pinscher', label: 'German Pinscher' },
  { value: 'German Shepherd', label: 'German Shepherd' },
  { value: 'German Shorthaired Pointer', label: 'German Shorthaired Pointer' },
  { value: 'German Wirehaired Pointer', label: 'German Wirehaired Pointer' },
  { value: 'Giant Schnauzer', label: 'Giant Schnauzer' },
  { value: 'Glen of Imaal Terrier', label: 'Glen of Imaal Terrier' },
  { value: 'Golden Retriever', label: 'Golden Retriever' },
  { value: 'Goldendoodle', label: 'Goldendoodle' },
  { value: 'Gordon Setter', label: 'Gordon Setter' },
  { value: 'Great Dane', label: 'Great Dane' },
  { value: 'Great Pyrenees', label: 'Great Pyrenees' },
  { value: 'Greater Swiss Mountain Dog', label: 'Greater Swiss Mountain Dog' },
  { value: 'Greyhound', label: 'Greyhound' },

  // H
  { value: 'Harrier', label: 'Harrier' },
  { value: 'Havanese', label: 'Havanese' },
  { value: 'Havapoo', label: 'Havapoo' },
  { value: 'Husky', label: 'Husky' },

  // I
  { value: 'Ibizan Hound', label: 'Ibizan Hound' },
  { value: 'Icelandic Sheepdog', label: 'Icelandic Sheepdog' },
  { value: 'Irish Red and White Setter', label: 'Irish Red and White Setter' },
  { value: 'Irish Setter', label: 'Irish Setter' },
  { value: 'Irish Terrier', label: 'Irish Terrier' },
  { value: 'Irish Water Spaniel', label: 'Irish Water Spaniel' },
  { value: 'Irish Wolfhound', label: 'Irish Wolfhound' },
  { value: 'Italian Greyhound', label: 'Italian Greyhound' },

  // J
  { value: 'Jack Russell Terrier', label: 'Jack Russell Terrier' },
  { value: 'Japanese Chin', label: 'Japanese Chin' },
  { value: 'Japanese Spitz', label: 'Japanese Spitz' },

  // K
  { value: 'Keeshond', label: 'Keeshond' },
  { value: 'Kerry Blue Terrier', label: 'Kerry Blue Terrier' },
  { value: 'King Charles Spaniel', label: 'King Charles Spaniel' },
  { value: 'Komondor', label: 'Komondor' },
  { value: 'Kuvasz', label: 'Kuvasz' },

  // L
  { value: 'Labradoodle', label: 'Labradoodle' },
  { value: 'Labrador Retriever', label: 'Labrador Retriever' },
  { value: 'Lakeland Terrier', label: 'Lakeland Terrier' },
  { value: 'Lancashire Heeler', label: 'Lancashire Heeler' },
  { value: 'Leonberger', label: 'Leonberger' },
  { value: 'Lhasa Apso', label: 'Lhasa Apso' },
  { value: 'Lowchen', label: 'Lowchen' },

  // M
  { value: 'Maltese', label: 'Maltese' },
  { value: 'Maltipoo', label: 'Maltipoo' },
  { value: 'Manchester Terrier', label: 'Manchester Terrier' },
  { value: 'Maremma Sheepdog', label: 'Maremma Sheepdog' },
  { value: 'Mastiff', label: 'Mastiff' },
  { value: 'Miniature American Shepherd', label: 'Miniature American Shepherd' },
  { value: 'Miniature Australian Shepherd', label: 'Miniature Australian Shepherd' },
  { value: 'Miniature Bull Terrier', label: 'Miniature Bull Terrier' },
  { value: 'Miniature Goldendoodle', label: 'Miniature Goldendoodle' },
  { value: 'Miniature Pinscher', label: 'Miniature Pinscher' },
  { value: 'Miniature Poodle', label: 'Miniature Poodle' },
  { value: 'Miniature Schnauzer', label: 'Miniature Schnauzer' },
  { value: 'Morkie', label: 'Morkie' },

  // N
  { value: 'Neapolitan Mastiff', label: 'Neapolitan Mastiff' },
  { value: 'Newfoundland', label: 'Newfoundland' },
  { value: 'Norfolk Terrier', label: 'Norfolk Terrier' },
  { value: 'Norwegian Buhund', label: 'Norwegian Buhund' },
  { value: 'Norwegian Elkhound', label: 'Norwegian Elkhound' },
  { value: 'Norwegian Lundehund', label: 'Norwegian Lundehund' },
  { value: 'Norwich Terrier', label: 'Norwich Terrier' },
  { value: 'Nova Scotia Duck Tolling Retriever', label: 'Nova Scotia Duck Tolling Retriever' },

  // O
  { value: 'Old English Sheepdog', label: 'Old English Sheepdog' },
  { value: 'Otterhound', label: 'Otterhound' },

  // P
  { value: 'Papillon', label: 'Papillon' },
  { value: 'Parson Russell Terrier', label: 'Parson Russell Terrier' },
  { value: 'Pekingese', label: 'Pekingese' },
  { value: 'Pembroke Welsh Corgi', label: 'Pembroke Welsh Corgi' },
  { value: 'Petit Basset Griffon Vendeen', label: 'Petit Basset Griffon Vendeen' },
  { value: 'Pharaoh Hound', label: 'Pharaoh Hound' },
  { value: 'Pit Bull', label: 'Pit Bull' },
  { value: 'Plott Hound', label: 'Plott Hound' },
  { value: 'Pointer', label: 'Pointer' },
  { value: 'Pomapoo', label: 'Pomapoo' },
  { value: 'Pomeranian', label: 'Pomeranian' },
  { value: 'Pomsky', label: 'Pomsky' },
  { value: 'Poodle', label: 'Poodle' },
  { value: 'Portuguese Water Dog', label: 'Portuguese Water Dog' },
  { value: 'Pug', label: 'Pug' },
  { value: 'Puggle', label: 'Puggle' },
  { value: 'Puli', label: 'Puli' },
  { value: 'Pumi', label: 'Pumi' },

  // R
  { value: 'Rat Terrier', label: 'Rat Terrier' },
  { value: 'Redbone Coonhound', label: 'Redbone Coonhound' },
  { value: 'Rhodesian Ridgeback', label: 'Rhodesian Ridgeback' },
  { value: 'Rottweiler', label: 'Rottweiler' },

  // S
  { value: 'Saint Bernard', label: 'Saint Bernard' },
  { value: 'Saluki', label: 'Saluki' },
  { value: 'Samoyed', label: 'Samoyed' },
  { value: 'Schipperke', label: 'Schipperke' },
  { value: 'Schnauzer', label: 'Schnauzer' },
  { value: 'Schnoodle', label: 'Schnoodle' },
  { value: 'Scottish Deerhound', label: 'Scottish Deerhound' },
  { value: 'Scottish Terrier', label: 'Scottish Terrier' },
  { value: 'Sealyham Terrier', label: 'Sealyham Terrier' },
  { value: 'Shetland Sheepdog', label: 'Shetland Sheepdog' },
  { value: 'Shiba Inu', label: 'Shiba Inu' },
  { value: 'Shih Tzu', label: 'Shih Tzu' },
  { value: 'Shihpoo', label: 'Shihpoo' },
  { value: 'Siberian Husky', label: 'Siberian Husky' },
  { value: 'Silky Terrier', label: 'Silky Terrier' },
  { value: 'Skye Terrier', label: 'Skye Terrier' },
  { value: 'Sloughi', label: 'Sloughi' },
  { value: 'Soft Coated Wheaten Terrier', label: 'Soft Coated Wheaten Terrier' },
  { value: 'Spanish Water Dog', label: 'Spanish Water Dog' },
  { value: 'Spinone Italiano', label: 'Spinone Italiano' },
  { value: 'Springer Spaniel', label: 'Springer Spaniel' },
  { value: 'Staffordshire Bull Terrier', label: 'Staffordshire Bull Terrier' },
  { value: 'Standard Poodle', label: 'Standard Poodle' },
  { value: 'Standard Schnauzer', label: 'Standard Schnauzer' },
  { value: 'Sussex Spaniel', label: 'Sussex Spaniel' },
  { value: 'Swedish Vallhund', label: 'Swedish Vallhund' },

  // T
  { value: 'Teddy Bear Dog', label: 'Teddy Bear Dog' },
  { value: 'Tibetan Mastiff', label: 'Tibetan Mastiff' },
  { value: 'Tibetan Spaniel', label: 'Tibetan Spaniel' },
  { value: 'Tibetan Terrier', label: 'Tibetan Terrier' },
  { value: 'Toy Fox Terrier', label: 'Toy Fox Terrier' },
  { value: 'Toy Poodle', label: 'Toy Poodle' },
  { value: 'Treeing Walker Coonhound', label: 'Treeing Walker Coonhound' },

  // V
  { value: 'Vizsla', label: 'Vizsla' },

  // W
  { value: 'Weimaraner', label: 'Weimaraner' },
  { value: 'Welsh Springer Spaniel', label: 'Welsh Springer Spaniel' },
  { value: 'Welsh Terrier', label: 'Welsh Terrier' },
  { value: 'West Highland White Terrier', label: 'West Highland White Terrier' },
  { value: 'Whippet', label: 'Whippet' },
  { value: 'Whoodle', label: 'Whoodle' },
  { value: 'Wire Fox Terrier', label: 'Wire Fox Terrier' },
  { value: 'Wirehaired Pointing Griffon', label: 'Wirehaired Pointing Griffon' },
  { value: 'Wirehaired Vizsla', label: 'Wirehaired Vizsla' },

  // X
  { value: 'Xoloitzcuintli', label: 'Xoloitzcuintli' },

  // Y
  { value: 'Yorkie-Poo', label: 'Yorkie-Poo' },
  { value: 'Yorkshire Terrier', label: 'Yorkshire Terrier' },
];

export default DOG_BREEDS;
